export default defineAppConfig({
    ui: {
        colors: {
            primary: '#0A2463',
            secondary: '#3E92CC'
        }
    }
})